import { useState } from 'react';
import { cn } from '@/lib/utils';
import { ShoppingCart, Grid3x3 } from 'lucide-react';
import { useBusinessType } from '@/features/pos/hooks/useBusinessType';

type POSTab = 'products' | 'tables';

interface POSTabsProps {
  activeTab: POSTab;
  onTabChange: (tab: POSTab) => void;
}

export const POSTabs = ({ activeTab, onTabChange }: POSTabsProps) => {
  const { features } = useBusinessType();
  
  return (
    <div className="bg-card border-b border-border">
      <div className="flex px-4">
        <button
          onClick={() => onTabChange('products')}
          className={cn(
            'flex items-center gap-2 px-6 py-3 font-medium border-b-2 transition-colors',
            activeTab === 'products'
              ? 'border-emerald-600 text-emerald-600'
              : 'border-transparent text-gray-600 hover:text-gray-900'
          )}
        >
          <ShoppingCart className="w-5 h-5" />
          <span>Produits / المنتجات</span>
        </button>

        {/* Tables tab - only for restaurants and cafes with table service */}
        {features.hasTableManagement && (
          <button
            onClick={() => onTabChange('tables')}
            className={cn(
              'flex items-center gap-2 px-6 py-3 font-medium border-b-2 transition-colors',
              activeTab === 'tables'
                ? 'border-emerald-600 text-emerald-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            )}
          >
            <Grid3x3 className="w-5 h-5" />
            <span>Tables / الطاولات</span>
          </button>
        )}
      </div>
    </div>
  );
};
